import { useEffect, useState } from "react";
import {
  askPermission,
  isPushSupported,
} from "../pages/UserSettings/NotificationSettings";
import ApiClient from "../backends/ApiClient";
import NotificationManager from "../components/notifications/NotificationManager";
import { useStores } from "../stores/useStores";
import { reportError } from "../utils/errorReporting";

export function usePushEnabled() {
  const [showPushMessage, setShowPushMessage] = useState(false);
  const { interfaceStore, userStore, organizationStore } = useStores();

  function enablePush() {
    setShowPushMessage(false);

    if (isPushSupported() && userStore.user) {
      navigator.serviceWorker.ready.then(function (registration) {
        askPermission()
          .then(function () {
            return registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey:
                "BFcZZ6FiITumPysCi_t9B1TANBHATH7r0Y4bKVRomTVRo14k5eNU0L9LhgZ3ogL7xPkGYh-RqtFN14RlnU3rDWg",
            });
          })
          .then(async function (pushSubscription) {
            const client = await ApiClient();
            await client.POST("/users/{user_pk}/push_subscription/", {
              params: { path: { user_pk: userStore.id } },
              body: {
                organization_id: organizationStore.currentOrganization.id,
                user_id: userStore.id,
                subscription_object: pushSubscription as unknown as Record<
                  string,
                  unknown
                >,
                user_agent: interfaceStore.userAgent,
                device_type:
                  interfaceStore.parsedUserAgent.device.type || "desktop",
              },
            });

            await client.PATCH("/organizations/{organization_pk}/users/{id}/", {
              params: {
                path: {
                  organization_pk: organizationStore.currentOrganization.id,
                  id: (userStore.user as IUser).id,
                },
              },
              // the spec types this partial-update body as the full UserRequest
              // (username required), but only `notifications` is actually sent (SBSB-2912)
              body: {
                notifications: {
                  phone: (userStore.user as IUser).notifications?.phone,
                  email: (userStore.user as IUser).notifications?.email,
                  voice: (userStore.user as IUser).notifications?.voice,
                  push: true,
                },
              } as never,
            });
            NotificationManager.success("Settings have been updated!");
          })
          .catch(function (subscriptionError) {
            reportError(subscriptionError, { error_source: "handled" });
            NotificationManager.error(subscriptionError.message);
          });
      });
    }
  }

  useEffect(() => {
    if (
      !isPushSupported() ||
      !navigator?.serviceWorker ||
      !("ready" in navigator.serviceWorker)
    ) {
      return;
    }

    navigator.serviceWorker.ready.then(() => {
      if (
        interfaceStore.isPWA &&
        userStore.user &&
        !userStore.user.notifications?.push
      ) {
        setShowPushMessage(true);
      }
    });
  }, []);

  return { showPushMessage, enablePush };
}
